<template>
  <div class="flexbox-container">
    <div v-for="(s, i) in group" :key="i" class="flexbox-row">
      <Card
        :name="s.name"
        :image="s.cover"
        :icon="s.thumbnail"
        :total-contents="s.totalContents"
        :type="type"
        :link="$urlBuilder(type, { slug: s.slug })"
      />
    </div>
  </div>
</template>

<script>
import Card from './Card';
export default {
  components: {
    Card
  },
  props: {
    group: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.flexbox-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  @include md {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}
.flexbox-row {
  flex-grow: 1;
  margin: 0px 20px;
  @include md {
    flex-grow: unset;
  }
}
.flexbox-row .container {
  margin: 1.5rem 0;
}
</style>
